import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: { //保存所有数据，以对象的方式导出
    userInfo: {},
    friendlink: [],
    allInfo: {},
    topSearchKeywords: "",
    headSearchKeywords:"",
    carJson: []
  },
  mutations: { //保存所有方法，用来改变state的数据
    init(state, ) {
      const allInfo = localStorage.getItem('allNews');
      if (allInfo) {
        const _info = JSON.parse(allInfo) || {};
        state.friendlink = _info.friendlink || [];
        state.userInfo = _info.userinfo || {};
        state.allInfo = _info;
      }
    },
    updateUserInfo(state, userInfo = {}) {
      state.userInfo = userInfo;
      localStorage.setItem('TIANYUE_USER_INFO', JSON.stringify(userInfo))
    },
    setCarJsonJSON(state, carJson) {
      state.carJson = carJson
      console.warn(carJson, "carJson");
    },
  },
  actions: { //暴露给用户使用，借此触发mutations中的方法，保存数据（可执行异步操作）
  },
  modules: {}
})
